export class Diagram {
  public displaySequence: Number;
  public keyDiagram: boolean;
  public label: string;
  public location: string;
}
